// extracted by mini-css-extract-plugin
export var avatarContainer = "_be-0";
export var avatarTypingWave = "_be-i";
export var gray = "_be-f";
export var green = "_be-c";
export var icon = "_be-9";
export var image = "_be-1";
export var lg = "_be-6";
export var md = "_be-5";
export var presenceDot = "_be-b";
export var red = "_be-d";
export var sm = "_be-4";
export var status = "_be-a";
export var typingDot = "_be-h";
export var typingPill = "_be-g";
export var xl = "_be-7";
export var xs = "_be-3";
export var xxl = "_be-8";
export var xxs = "_be-2";
export var yellow = "_be-e";